<template>
<div class="chapter">
<div class="inner_page">
<p class="C63"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C71"><a id="page_vii"></a><a href="#/xhtml/05_Acknowledgments#page_ix">Acknowledgments</a></p>
<p class="C72"><a href="#/xhtml/06_Author_s_Notes#page_xv">Author’s Notes</a></p>
<p class="C71"><a href="#/xhtml/07_Introduction#page_1">Introduction</a></p>
<p class="C71"><span href="#/xhtml/08_1__Sex_in_Gray_Spaces#page_24" title="Link target outside of Sample">1. Sex in Gray Spaces</span></p>
<p class="C71"><span href="#/xhtml/09_2__First_Timers_Welcome#page_47" title="Link target outside of Sample">2. First-Timers Welcome!</span></p>
<p class="C71"><span href="#/xhtml/10_3__Stigma_and_the_Moral_Economy#page_73" title="Link target outside of Sample">3. Stigma and the Moral Economy</span></p>
<p class="C71"><span href="#/xhtml/11_4__Healing_Customers#page_99" title="Link target outside of Sample">4. Healing Customers</span></p>
<p class="C71"><span href="#/xhtml/12_5__Victims_All#page_122" title="Link target outside of Sample">5. Victims All</span></p>
<p class="C71"><span href="#/xhtml/13_6__Risk_and_Rights#page_146" title="Link target outside of Sample">6. Risk and Rights</span></p>
<p class="C72"><span href="#/xhtml/14_Epilogue#page_171" title="Link target outside of Sample">Epilogue</span></p>
<p class="C71"><span href="#/xhtml/15_Notes#page_175" title="Link target outside of Sample">Notes</span></p>
<p class="C71"><span href="#/xhtml/16_Glossary#page_197" title="Link target outside of Sample">Glossary</span></p>
<p class="C71"><span href="#/xhtml/17_Bibliography#page_201" title="Link target outside of Sample">Bibliography</span></p>
<p class="C71"><span href="#/xhtml/18_Index#page_221" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?7852b081